function getPublishState(state) {
  return {
    isLoading: state.publish.loading,
    fetchResponse: state.publish.data,
    recievedSuccessfulResponse: state.publish.recievedSuccessfulResponse,
    recievedErrorResponse: state.publish.recievedErrorResponse,
    currentPosting: state.publish.currentPosting,
    bulkSuccessful: state.publish.bulkSuccessful,
    bulkError: state.publish.bulkError
  };
}

export { getPublishState };
